const PERIODS = [
  { value: 'today', label: 'Hoy' },
  { value: 'week', label: 'Semana' },
  { value: 'month', label: 'Mes' },
  { value: 'quarter', label: 'Trimestre' },
  { value: 'year', label: 'Anual' },
];

export default function DateFilter({ selected, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
      {PERIODS.map((p) => (
        <button
          key={p.value}
          onClick={() => onChange(p.value)}
          style={{
            padding: '6px 16px', borderRadius: 20, border: '1px solid #ddd',
            background: selected === p.value ? '#1a1a2e' : '#fff',
            color: selected === p.value ? '#fff' : '#333',
            cursor: 'pointer', fontSize: 13,
          }}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
